<template>
  <div class="table-container" :class="{ hidePag: tableData.length < 9 }">
    <DataTable
      :value="tableData"
      paginator
      :rows="8"
      tableStyle="min-width: 50rem"
    >
      <template #empty>
        <div class="no-data-table">
          <img :src="noDataImg" alt="" />
          <div>{{ $t('dataTable.noDataToShow') }}</div>
        </div>
      </template>
      <Column
        v-for="head in HeadOfTable"
        :key="head"
        :field="head.headKey"
        sortable
        :header="head.headText"
      >
      </Column>

      <Column header="" v-if="showLink">
        <template #body="slotProps">
          <div class="d-flex">
            <!-- edit  -->
            <router-link
              :to="'/' + linkDirection + '/' + slotProps.data.id"
              class="show_more"
            >
              {{ $t('dataTable.showDetails') }}
            </router-link>
          </div>
        </template>
      </Column>
      <Column header="" v-if="showEditRemove">
        <template #body="slotProps">
          <div class="flex-sm-gap">
            <!-- edit  -->
            <router-link
              :to="'/' + 'editTechnicain' + '/' + slotProps.data.id"
              class="editRadios"
            >
              <i class="fa-regular fa-pen-to-square"></i>
            </router-link>
            <div class="editRadios bg-light-red" @click="$emit('openModal' , slotProps.data.id)">
              <i class="fa-solid fa-trash-can"></i>
            </div>
          </div>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script setup>
// imports
import { ref, onMounted, defineProps } from "vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";

//props
const props = defineProps([
  "tableData",
  "showLink",
  "linkDirection",
  "HeadOfTable",
  "showEditRemove",
]);

// reactive state
const noDataImg = ref(require("../../assets/imgs/7486744.png"));

// lifecycle hooks
onMounted(() => {
  console.log(props);
});
</script>
